import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, EmptyState } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import 'content-visibility';
import { Item } from './Item';
import { LoadingState } from './LoadingState';
import { useComposers } from './useComposers';
import { useComposerData } from '../../ComposerDataProvider';
import { ErrorState } from '../ErrorState';
import { EmptyContent, GridContent, contentVisibilityStyle } from './styled';
export function Grid() {
    const { selectComposer, searchQuery, setSearchQuery } = useComposerData();
    const { composers, loading, error } = useComposers();
    const handleEmptyStateButtonClick = () => setSearchQuery('');
    if (loading) {
        return <LoadingState />;
    }
    if (error) {
        return <ErrorState />;
    }
    if (composers.length > 0) {
        return (<content-visibility style={contentVisibilityStyle}>
        <GridContent>
          {composers.map((composer) => (<Item key={composer.id} composer={composer} onClick={selectComposer}/>))}
        </GridContent>
      </content-visibility>);
    }
    return (<EmptyContent>
      <EmptyState icon={<Falcon icon="search"/>} title={t({
            comment: 'Select template dialog - empty search title',
            message: 'No templates found',
        })} description={t({
            comment: 'Select template dialog - empty search description',
            message: "We don't seem to have the template you're looking for",
        })} actions={searchQuery.length > 0 && (<Button appearance="secondary" onClick={handleEmptyStateButtonClick}>
              <Trans comment="Select template dialog - empty search button label">Clear search</Trans>
            </Button>)}/>
    </EmptyContent>);
}
